/**
 * 빌드 화면 아래 생성기 — 늘 마운트해 둔다. 쓰던 입력(주제·자료·조건)을 닫았다 열어도 남기고, 입력창이
 * 닫힌 채 진행 중인 생성(useAiGenerateDockRun 의 AbortController)도 끊지 않기 위해서다.
 * 입력창은 aiGenerateDockInputShownAtom 일 때만 보인다 — 생성 중엔 생성 중 토스트가 대신한다.
 * 채팅 패널이 열리거나 설정 단계로 넘어가면 숨기기만 한다.
 */
import { useAtomValue, useSetAtom } from 'jotai';
import { useAiGenerateDockCopy } from '../hooks/useAiGenerateDockCopy';
import { useRequestAiGenerateDock } from '../hooks/useRequestAiGenerateDock';
import { aiGenerateDockInputShownAtom, aiGenerateDockUiAtom } from '../stores/aiGenerateDock.atoms';
import { AiGenerateDock } from './AiGenerateDock';
export const AiGenerateDockMount = ({
  visible
}: {
  visible: boolean;
}) => {
  const dispatchUi = useSetAtom(aiGenerateDockUiAtom);
  const inputShown = useAtomValue(aiGenerateDockInputShownAtom);
  // 다시 열기도 진입 카드와 같은 열기 요청 — 가득 찼으면 열지 않고 상한 토스트만 띄운다.
  const requestDock = useRequestAiGenerateDock();
  const {
    copy,
    runCopy,
    onboardingCopy
  } = useAiGenerateDockCopy();
  return <div data-testid="ai-generate-dock-mount" hidden={!visible} data-sentry-component="AiGenerateDockMount" data-sentry-source-file="AiGenerateDockMount.tsx">
      <AiGenerateDock copy={copy} runCopy={runCopy} onboardingCopy={onboardingCopy} open={inputShown} visible={visible} onClose={() => dispatchUi({
      type: 'close'
    })} onReopen={sourceType => requestDock(sourceType)} data-sentry-element="AiGenerateDock" data-sentry-source-file="AiGenerateDockMount.tsx" />
    </div>;
};